// extracted by mini-css-extract-plugin
module.exports = {"Config":"config_Config__2Pqo9"};